import React, {
	useEffect,
	useState
} from 'react';
import { useParams } from 'react-router-dom';
import { EngagementExpandedSummary } from '../../models/dto/engagement';
import PageLoadingSpinner from '../PageLoadingSpinner';
import api from '../../helpers/api';
import CreateBasicJobPage from './CreateBasicJobPage';
import CreateJobPage from './CreateJobPage';

export default function CreateJobPageRouter() {
	const engagementId = parseInt(useParams<any>().engagementId);
	const [engagement, setEngagement] = useState<EngagementExpandedSummary | null>(null);
	
	useEffect(() => {
		api.get<EngagementExpandedSummary>(`/api/engagements/${engagementId}`).then(response => {
			setEngagement(response.data);
		});
	}, [engagementId]);

	if (!engagement) {
		return <PageLoadingSpinner />;
	}
	
	if (engagement.skipMetadata) {
		return <CreateBasicJobPage engagementId={engagement.id} />
	} else {
		return <CreateJobPage engagementId={engagement.id} />
	}
}
